module.exports = __webpack_public_path__ + "../resources/img/ic_fog_weather.36cd9ff3.svg";